import $ from 'jquery';

const autoscroll = function () {
  const blocks = $('[autoscroll-contents]');
  // One full loop, in ms. Higher is slower. data-marquee-duration overrides it per
  // block, so one carousel can be retimed without retiming every marquee.
  var defaultSpeed = $(window).width() > 767 ? 30000 : 20000;

  blocks.removeClass('d-flex');

  blocks.each(function () {
    var $block = $(this);
    var override = parseInt($block.attr('data-marquee-duration'), 10);

    $block.marquee({
      duration: override > 0 ? override : defaultSpeed,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startPosition: 2,
      startVisible: true
    });
  });
}

export default autoscroll;